import { render, staticRenderFns } from "./completed.vue?vue&type=template&id=665bcb4a&scoped=true&"
import script from "./completed.vue?vue&type=script&lang=js&"
export * from "./completed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665bcb4a",
  null
  
)

export default component.exports